export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never};
export type Incremental<T> = T | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string};
  String: {input: string; output: string};
  Boolean: {input: boolean; output: boolean};
  Int: {input: number; output: number};
  Float: {input: number; output: number};
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: {input: any; output: any};
  _FieldSet: {input: any; output: any};
};

/** Account Token Object */
export type AccountToken = {
  __typename?: 'AccountToken';
  /** Access Token for the account */
  accessToken: Scalars['String']['output'];
  /** Expiry time in seconds */
  expiry?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the account token */
  id: Scalars['ID']['output'];
  /** Name of the account */
  name: Scalars['String']['output'];
  /** Avatar url */
  photoURL?: Maybe<Scalars['String']['output']>;
  /** Type of the account */
  provider: AccountTokenProvider;
  /** Refresh Token for the account */
  refreshToken: Scalars['String']['output'];
  /** Scope of token */
  scope: Array<Scalars['String']['output']>;
  /** Shop id of the account */
  shopId?: Maybe<Scalars['Int']['output']>;
  /** Type of the account */
  type?: Maybe<Scalars['String']['output']>;
  /** User id of the account */
  userId: Scalars['Int']['output'];
};

export enum AccountTokenProvider {
  ETSY = 'ETSY',
}

/** Base64 Encoded Object */
export type Base64Object = {
  __typename?: 'Base64Object';
  /** Base64 encoded data */
  data: Scalars['String']['output'];
  /** Name of the file */
  name: Scalars['String']['output'];
  /** MIME type of the file */
  type: Scalars['String']['output'];
};

/** Base64 Encoded file input */
export type Base64ObjectInput = {
  /** Base64 encoded data */
  data: Scalars['String']['input'];
  /** Name of the file */
  name: Scalars['String']['input'];
  /** MIME type of the file */
  type: Scalars['String']['input'];
};

/** Reason for the contact message */
export enum ContactCategory {
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  FEEDBACK = 'FEEDBACK',
  GENERAL = 'GENERAL',
  OTHER = 'OTHER',
  SUPPORT = 'SUPPORT',
}

/** Contact Message Object */
export type ContactMessage = {
  __typename?: 'ContactMessage';
  /** Attachments in Base64 format */
  attachments: Array<Base64Object>;
  /** Category of the message */
  category: ContactCategory;
  createdAt: Scalars['DateTimeISO']['output'];
  /** Email of the sender */
  email: Scalars['String']['output'];
  /** id of message */
  id: Scalars['ID']['output'];
  /** Message content */
  message: Scalars['String']['output'];
  /** Name of the sender */
  name: Scalars['String']['output'];
};

/** Contact Message Input */
export type ContactMessageInput = {
  /** Attachments in Base64 format */
  attachments: Array<Base64ObjectInput>;
  /** Category of the message */
  category: ContactCategory;
  /** Email of the sender */
  email: Scalars['String']['input'];
  /** Message content */
  message: Scalars['String']['input'];
  /** Name of the sender */
  name: Scalars['String']['input'];
};

/** Coupon Code Object */
export type CouponCode = {
  __typename?: 'CouponCode';
  /** The Role this coupon will grant */
  couponRole: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  /** UID of the creator */
  createdBy: Scalars['String']['output'];
  /** Duration of the coupon in days, 1-365 days */
  durationDays: Scalars['Int']['output'];
  expiryDate: Scalars['DateTimeISO']['output'];
  expiryDays: Scalars['Int']['output'];
  /** Unique identifier for the coupon code, generated by the system */
  id: Scalars['ID']['output'];
  /** Optional cap on number of uses */
  maxUses?: Maybe<Scalars['Float']['output']>;
  /** Display label */
  name: Scalars['String']['output'];
  /** Status of the coupon code */
  status: CouponStatus;
  /** Number of times the code has been used */
  usedCount: Scalars['Float']['output'];
};

/** Input for creating a coupon code */
export type CouponCodeInput = {
  /** The Role this coupon will grant */
  couponRole: Scalars['String']['input'];
  /** Duration of the coupon in days, 1-365 days */
  durationDays: Scalars['Int']['input'];
  /** When the coupon expires, in days, 1-365 days */
  expiryDays: Scalars['Int']['input'];
  /** Unique identifier for the coupon code, this is used to redeem the coupon. This is case-insensitive. */
  id: Scalars['String']['input'];
  /** Optional cap on number of uses, 0 for unlimited */
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  /** Display label, can be changed */
  name: Scalars['String']['input'];
  /** Status of the coupon code, if not provided, will not be updated */
  status?: InputMaybe<CouponStatus>;
};

/** Input for updating a coupon code */
export type CouponCodeUpdateInput = {
  /** The Role this coupon will grant */
  couponRole?: InputMaybe<Scalars['String']['input']>;
  /** Duration of the coupon in days, 1-365 days */
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  /** When the coupon expires, in days, 1-365 days */
  expiryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Optional cap on number of uses, 0 for unlimited */
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  /** Display label, can be changed */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Status of the coupon code, if not provided, will not be updated */
  status?: InputMaybe<CouponStatus>;
};

/** Status of a coupon code */
export enum CouponStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

/** The supported currencies for pricing and transactions */
export enum Currency {
  gbp = 'gbp',
  usd = 'usd',
}

/** bulk create list from csv */
export type EtsyBulkCreateCsv = {
  __typename?: 'EtsyBulkCreateCsv';
  /** Item to be created */
  items: Array<EtsyBulkCreateCsvItem>;
  /** etsy shop id */
  shopRecordId: Scalars['String']['output'];
};

export type EtsyBulkCreateCsvInput = {
  /** Array of product/folder to be uploaded */
  items: Array<EtsyBulkCreateCsvItemInput>;
  /** etsy shop id */
  shopRecordId: Scalars['String']['input'];
};

/** Individual item within a bulk Etsy upload job */
export type EtsyBulkCreateCsvItem = {
  __typename?: 'EtsyBulkCreateCsvItem';
  /** Error message if the item failed */
  error?: Maybe<Scalars['String']['output']>;
  /** etsy listing stringified */
  etsyListingStringified: Scalars['String']['output'];
  /** item id */
  id: Scalars['String']['output'];
  /** image url of the item */
  images?: Maybe<Array<Scalars['String']['output']>>;
  /** sku of the item */
  sku: Scalars['String']['output'];
  /** Status of the item */
  status: JobDetailStatus;
};

export type EtsyBulkCreateCsvItemInput = {
  /** etsy listing stringified */
  etsyListingStringified: Scalars['String']['input'];
  /** image url of the item */
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sku of the item */
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** bulk upload with folder containing lots of individual items */
export type EtsyBulkCreateGdriveFile = {
  __typename?: 'EtsyBulkCreateGdriveFile';
  /** Google Drive URL for the upload source */
  gdriveUrl: Scalars['String']['output'];
  /** folder name for image */
  imageFolder: Scalars['String']['output'];
  /** Array of product/folder to be uploaded */
  items: Array<EtsyBulkCreateGdriveFileItem>;
  /** folder name for digital product */
  productFolder: Scalars['String']['output'];
  /** etsy shop id */
  shopRecordId: Scalars['String']['output'];
  /** JSON string of EtsyListing for building template */
  template: Scalars['String']['output'];
};

export type EtsyBulkCreateGdriveFileInput = {
  /** Google Drive URL for the upload source */
  gdriveUrl: Scalars['String']['input'];
  /** folder name for image */
  imageFolder: Scalars['String']['input'];
  /** Array of product/folder to be uploaded */
  items: Array<EtsyBulkCreateGdriveFileItemInput>;
  /** folder name for digital product */
  productFolder: Scalars['String']['input'];
  /** etsy shop id */
  shopRecordId: Scalars['String']['input'];
  /** JSON string of EtsyListing for building template */
  template: Scalars['String']['input'];
};

/** Individual item within a bulk Etsy upload job */
export type EtsyBulkCreateGdriveFileItem = {
  __typename?: 'EtsyBulkCreateGdriveFileItem';
  /** Error message if the item failed */
  error?: Maybe<Scalars['String']['output']>;
  /** item id in gdrive */
  gdriveId: Scalars['String']['output'];
  /** item id */
  id: Scalars['String']['output'];
  /** Name of the item */
  name: Scalars['String']['output'];
  /** Status of the item */
  status: JobDetailStatus;
};

export type EtsyBulkCreateGdriveFileItemInput = {
  /** item id in gdrive */
  gdriveId: Scalars['String']['input'];
  /** Full file name of the item */
  name: Scalars['String']['input'];
};

/** Individual item within a bulk Etsy upload job */
export type EtsyBulkCreateGdriveFolder = {
  __typename?: 'EtsyBulkCreateGdriveFolder';
  /** Google Drive URL for the upload source */
  gdriveUrl: Scalars['String']['output'];
  /** folder name for image */
  imageFolder: Scalars['String']['output'];
  /** Array of product/folder to be uploaded */
  items: Array<EtsyBulkCreateGdriveFolderItem>;
  /** folder name for digital product */
  productFolder: Scalars['String']['output'];
  /** etsy shop id */
  shopRecordId: Scalars['String']['output'];
  /** JSON string of EtsyListing for building template */
  template: Scalars['String']['output'];
};

export type EtsyBulkCreateGdriveFolderInput = {
  /** Google Drive URL for the upload source */
  gdriveUrl: Scalars['String']['input'];
  /** folder name for image */
  imageFolder: Scalars['String']['input'];
  /** Array of product/folder to be uploaded */
  items: Array<EtsyBulkCreateGdriveFolderItemInput>;
  /** folder name for digital product */
  productFolder: Scalars['String']['input'];
  /** etsy shop id */
  shopRecordId: Scalars['String']['input'];
  /** JSON string of EtsyListing for building template */
  template: Scalars['String']['input'];
};

/** Individual item within a bulk Etsy upload job */
export type EtsyBulkCreateGdriveFolderItem = {
  __typename?: 'EtsyBulkCreateGdriveFolderItem';
  /** Error message if the item failed */
  error?: Maybe<Scalars['String']['output']>;
  /** item id in gdrive */
  gdriveId: Scalars['String']['output'];
  /** item id */
  id: Scalars['String']['output'];
  /** Name of the item */
  name: Scalars['String']['output'];
  /** Status of the item */
  status: JobDetailStatus;
};

export type EtsyBulkCreateGdriveFolderItemInput = {
  /** item id in gdrive */
  gdriveId: Scalars['String']['input'];
  /** Name of the item */
  name: Scalars['String']['input'];
};

/** bulk update list from csv */
export type EtsyBulkUpdateCsv = {
  __typename?: 'EtsyBulkUpdateCsv';
  /** Item to be created */
  items: Array<EtsyBulkUpdateCsvItem>;
  /** etsy shop id */
  shopRecordId: Scalars['String']['output'];
};

export type EtsyBulkUpdateCsvInput = {
  /** Array of product/folder to be uploaded */
  items: Array<EtsyBulkUpdateCsvItemInput>;
  /** etsy shop id */
  shopRecordId: Scalars['String']['input'];
};

/** Individual item within a bulk Etsy upload job */
export type EtsyBulkUpdateCsvItem = {
  __typename?: 'EtsyBulkUpdateCsvItem';
  /** Error message if the item failed */
  error?: Maybe<Scalars['String']['output']>;
  /** item id */
  id: Scalars['String']['output'];
  /** etsy listing id */
  listingId: Scalars['Float']['output'];
  /** Status of the item */
  status: JobDetailStatus;
  /** tags of the item */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** title of the item */
  title?: Maybe<Scalars['String']['output']>;
};

export type EtsyBulkUpdateCsvItemInput = {
  /** etsy listing id */
  listingId: Scalars['Float']['input'];
  /** tags of the item */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** title of the item */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Feature enum */
export enum FeatureEnum {
  createDraftListing = 'createDraftListing',
  etsyBulkCreateCsv = 'etsyBulkCreateCsv',
  etsyBulkCreateGdriveFile = 'etsyBulkCreateGdriveFile',
  etsyBulkCreateGdriveFolder = 'etsyBulkCreateGdriveFolder',
  etsyBulkUpdateCsv = 'etsyBulkUpdateCsv',
  updateEtsyListing = 'updateEtsyListing',
}

export type FeatureUsageFilterInput = {
  /** End date in YYYY-MM-DD format, defaults to today */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Start date in YYYY-MM-DD format, defaults to beginning of current month */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** Feature Usage Quota Object */
export type FeatureUsageQuota = {
  __typename?: 'FeatureUsageQuota';
  /** id of quota record */
  id: FeatureEnum;
  /** Maximum quota limit */
  quota: Scalars['Int']['output'];
  /** Current usage count */
  usage: Scalars['Int']['output'];
};

export type GDriveItem = {
  __typename?: 'GDriveItem';
  children?: Maybe<Array<GDriveItem>>;
  id: Scalars['String']['output'];
  isFolder: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  webViewLink: Scalars['String']['output'];
};

export type GenImage = {
  __typename?: 'GenImage';
  errorMessage?: Maybe<Scalars['String']['output']>;
  filePath: Scalars['String']['output'];
  /** document id, auto generated when created */
  id: Scalars['String']['output'];
  lastUpdate: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  status: GenImageStatus;
  tries: Scalars['Float']['output'];
  uid: Scalars['String']['output'];
};

export enum GenImageStatus {
  DISABLE = 'DISABLE',
  ERROR = 'ERROR',
  QUEUE = 'QUEUE',
  SUCCESS = 'SUCCESS',
}

/** Status of an individual item */
export enum JobDetailStatus {
  ERROR = 'ERROR',
  QUEUE = 'QUEUE',
  SUCCESS = 'SUCCESS',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Add a GenImage document */
  addGenImage: Scalars['String']['output'];
  /** Add multiple GenImage documents */
  addMultipleGenImages: Array<Scalars['String']['output']>;
  /** Create a new Contact Message */
  createContactMessage: ContactMessage;
  createCouponCode: CouponCode;
  /** Create a new QueueJob item */
  createQueueJob: QueueJob;
  createStripeCheckoutSession: StripeCheckoutSession;
  /** Delete an Account Token */
  deleteAccountToken: Scalars['Boolean']['output'];
  deleteCouponCode: Scalars['Boolean']['output'];
  /** Delete a GenImage document by prompt */
  deleteGenImage: Scalars['Boolean']['output'];
  /** Delete a QueueJob item */
  deleteQueueJob: Scalars['Boolean']['output'];
  /** Delete a User API Account */
  deleteUserApiAccount: Scalars['Boolean']['output'];
  redeemCouponCode: Scalars['Boolean']['output'];
  removeCouponClaims: Scalars['Boolean']['output'];
  /** Resume a QueueJob */
  resumeQueueJob: Scalars['Boolean']['output'];
  updateCouponCode?: Maybe<CouponCode>;
  /** Update a GenImage document */
  updateGenImage: Scalars['Boolean']['output'];
};

export type MutationAddGenImageArgs = {
  prompt: Scalars['String']['input'];
};

export type MutationAddMultipleGenImagesArgs = {
  prompts: Array<Scalars['String']['input']>;
};

export type MutationCreateContactMessageArgs = {
  contactMessage: ContactMessageInput;
};

export type MutationCreateCouponCodeArgs = {
  input: CouponCodeInput;
};

export type MutationCreateQueueJobArgs = {
  job: QueueJobInput;
};

export type MutationCreateStripeCheckoutSessionArgs = {
  allowPromotionCodes?: InputMaybe<Scalars['Boolean']['input']>;
  cancelUrl: Scalars['String']['input'];
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethodCollection?: InputMaybe<PaymentMethodCollection>;
  priceId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

export type MutationDeleteAccountTokenArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteCouponCodeArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteGenImageArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteQueueJobArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteUserApiAccountArgs = {
  name: Scalars['String']['input'];
};

export type MutationRedeemCouponCodeArgs = {
  code: Scalars['String']['input'];
};

export type MutationResumeQueueJobArgs = {
  id: Scalars['String']['input'];
};

export type MutationUpdateCouponCodeArgs = {
  id: Scalars['String']['input'];
  input: CouponCodeUpdateInput;
};

export type MutationUpdateGenImageArgs = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GenImageStatus>;
  tries?: InputMaybe<Scalars['Float']['input']>;
};

/** Payment method collection strategy for checkout sessions */
export enum PaymentMethodCollection {
  ALWAYS = 'ALWAYS',
  IF_REQUIRED = 'IF_REQUIRED',
}

/** Price Object */
export type Price = {
  __typename?: 'Price';
  /** Whether the product is active */
  active: Scalars['Boolean']['output'];
  /** Currency code */
  currency: Currency;
  /** Price ID */
  id: Scalars['ID']['output'];
  /** Billing interval (month or year) */
  interval?: Maybe<PriceInterval>;
  /** Number of intervals between billings */
  intervalCount?: Maybe<Scalars['Int']['output']>;
  /** Price type (recurring or one_time) */
  type: PriceType;
  /** Price amount in smallest currency unit */
  unitAmount: Scalars['Int']['output'];
};

/** The interval at which a subscription price is billed */
export enum PriceInterval {
  month = 'month',
  year = 'year',
}

/** The type of price (recurring subscription or one-time payment) */
export enum PriceType {
  one_time = 'one_time',
  recurring = 'recurring',
}

/** Product Object */
export type Product = {
  __typename?: 'Product';
  /** Whether the product is active */
  active: Scalars['Boolean']['output'];
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Features */
  features: Array<Scalars['String']['output']>;
  /** Product ID */
  id: Scalars['ID']['output'];
  /** Product name */
  name: Scalars['String']['output'];
  /** List of prices for this product */
  prices: Array<Price>;
  /** Quotas */
  quotas: Array<Scalars['String']['output']>;
  /** Role name */
  role: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  countCouponCodes: Scalars['Int']['output'];
  /** Get an Account Token by name */
  getAccountToken?: Maybe<AccountToken>;
  /** Get all GenImage documents */
  getAllGenImages: Array<GenImage>;
  /** Get a Contact Message by id and email */
  getContactMessage?: Maybe<ContactMessage>;
  getCouponCode?: Maybe<CouponCode>;
  /** Get a summary of feature usage */
  getFeatureUsage: Array<Scalars['String']['output']>;
  /** Get feature usage with quota information */
  getFeatureUsageWithQuota: Array<FeatureUsageQuota>;
  /** Get google drive content */
  getGDriveContent: GDriveItem;
  /** Get a GenImage by id */
  getGenImage?: Maybe<GenImage>;
  /** Get a GenImage by prompt */
  getGenImageByPrompt?: Maybe<GenImage>;
  getProducts: Array<Product>;
  getStripeCheckoutSession?: Maybe<StripeCheckoutSession>;
  getStripePortalLink: StripePortal;
  getUser?: Maybe<UserAccount>;
  /** Get a User API Account by name */
  getUserApiAccount?: Maybe<UserApiAccount>;
  /** List all Account Tokens for the user */
  listAccountTokens: Array<AccountToken>;
  /** List all Contact Messages for the user */
  listAllContactMessages: Array<ContactMessage>;
  /** List all Contact Messages for the user */
  listContactMessages: Array<ContactMessage>;
  listCouponCodes: Array<CouponCode>;
  /** List all QueueJob items for the user */
  listQueueJob: Array<QueueJob>;
  /** List all User API Accounts for the user */
  listUserApiAccounts: Array<UserApiAccount>;
};

export type QueryGetAccountTokenArgs = {
  name: Scalars['String']['input'];
};

export type QueryGetAllGenImagesArgs = {
  status?: InputMaybe<GenImageStatus>;
};

export type QueryGetContactMessageArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type QueryGetCouponCodeArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetGDriveContentArgs = {
  folderId: Scalars['String']['input'];
};

export type QueryGetGenImageArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetGenImageByPromptArgs = {
  prompt: Scalars['String']['input'];
};

export type QueryGetStripeCheckoutSessionArgs = {
  sessionId: Scalars['String']['input'];
};

export type QueryGetStripePortalLinkArgs = {
  returnUrl: Scalars['String']['input'];
};

export type QueryGetUserApiAccountArgs = {
  name: Scalars['String']['input'];
};

export type QueryListAllContactMessagesArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListContactMessagesArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListCouponCodesArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<CouponStatus>;
};

export type QueryListQueueJobArgs = {
  input?: InputMaybe<QueueJobListInput>;
};

/** queued job */
export type QueueJob = {
  __typename?: 'QueueJob';
  /** Unix timestamp (seconds) when the job was created */
  creationTimestamp: Scalars['Float']['output'];
  /** Number of error items, reset when job is resumed */
  errorCount: Scalars['Float']['output'];
  /** Data for etsy bulk create csv */
  etsyBulkCreateCsv?: Maybe<EtsyBulkCreateCsv>;
  /** Data for etsy bulk upload gdrive file */
  etsyBulkCreateGdriveFile?: Maybe<EtsyBulkCreateGdriveFile>;
  /** Data for etsy bulk upload */
  etsyBulkCreateGdriveFolder?: Maybe<EtsyBulkCreateGdriveFolder>;
  /** Data for etsy bulk update csv */
  etsyBulkUpdateCsv?: Maybe<EtsyBulkUpdateCsv>;
  /** Unix timestamp (seconds) when the job expires and can be deleted */
  expireTimestamp: Scalars['Float']['output'];
  /** Unique identifier for the job (not stored in Firestore document) */
  id: Scalars['String']['output'];
  /** Unix timestamp (seconds) when the job was created */
  lastUpdateTimestamp: Scalars['Float']['output'];
  /** Status of the job */
  status: QueueJobStatus;
};

/** Content of a job */
export enum QueueJobContent {
  etsyBulkCreateCsv = 'etsyBulkCreateCsv',
  etsyBulkCreateGdriveFile = 'etsyBulkCreateGdriveFile',
  etsyBulkCreateGdriveFolder = 'etsyBulkCreateGdriveFolder',
  etsyBulkUpdateCsv = 'etsyBulkUpdateCsv',
}

export type QueueJobInput = {
  /** Data for etsy bulk create csv */
  etsyBulkCreateCsv?: InputMaybe<EtsyBulkCreateCsvInput>;
  /** Data for etsy bulk create gdrive file */
  etsyBulkCreateGdriveFile?: InputMaybe<EtsyBulkCreateGdriveFileInput>;
  /** Data for etsy bulk create gdrive folder */
  etsyBulkCreateGdriveFolder?: InputMaybe<EtsyBulkCreateGdriveFolderInput>;
  /** Data for etsy bulk update csv */
  etsyBulkUpdateCsv?: InputMaybe<EtsyBulkUpdateCsvInput>;
};

export type QueueJobListInput = {
  /** Filter by job content type */
  content?: InputMaybe<QueueJobContent>;
  /** Limit number of records returned */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Offset for pagination */
  offset?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by job status */
  status?: InputMaybe<QueueJobStatus>;
};

/** Status of a job */
export enum QueueJobStatus {
  COMPLETE = 'COMPLETE',
  PAUSED = 'PAUSED',
  QUEUE = 'QUEUE',
}

/** Checkout Session Object */
export type StripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  /** Whether to allow promotion codes during checkout */
  allow_promotion_codes?: Maybe<Scalars['Boolean']['output']>;
  /** Cancel URL */
  cancel_url: Scalars['String']['output'];
  /** Error message if any */
  error?: Maybe<Scalars['String']['output']>;
  /** Checkout Session ID */
  id: Scalars['ID']['output'];
  /** Metadata */
  metadata?: Maybe<Array<Scalars['String']['output']>>;
  /** Mode */
  mode: Scalars['String']['output'];
  /** Payment method collection strategy */
  payment_method_collection?: Maybe<PaymentMethodCollection>;
  /** Price ID */
  price: Scalars['String']['output'];
  /** Success URL */
  success_url: Scalars['String']['output'];
  /** Checkout URL */
  url?: Maybe<Scalars['String']['output']>;
};

/** Stripe Customer Portal Object */
export type StripePortal = {
  __typename?: 'StripePortal';
  /** Error message if any */
  error?: Maybe<Scalars['String']['output']>;
  /** Portal Session ID */
  id: Scalars['ID']['output'];
  /** Return URL */
  return_url: Scalars['String']['output'];
  /** Portal URL */
  url?: Maybe<Scalars['String']['output']>;
};

/** Stripe Subscription Object associated with a user */
export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  /** Currency code */
  currency: Currency;
  /** Subscription end date for current period */
  endDate: Scalars['String']['output'];
  /** Feature list associated with subscription */
  features: Array<Scalars['String']['output']>;
  /** Subscription ID */
  id: Scalars['ID']['output'];
  /** Billing interval (month or year) */
  interval?: Maybe<PriceInterval>;
  /** Quota associated with subscription, needs to be mapped back to Record<FeatureEnum,number> */
  quota: Array<Scalars['String']['output']>;
  /** User role associated with subscription */
  role: Scalars['String']['output'];
  /** Subscription start date for current period */
  startDate: Scalars['String']['output'];
  /** Price amount in smallest currency unit */
  unitAmount: Scalars['Int']['output'];
};

export type UserAccount = {
  __typename?: 'UserAccount';
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  lastLoginAt: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  photoURL: Scalars['String']['output'];
  /** Get the stripe role of the user */
  role?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<StripeSubscription>;
  uid: Scalars['String']['output'];
};

/** User API Account Object */
export type UserApiAccount = {
  __typename?: 'UserApiAccount';
  /** API Key for the account */
  apiKey: Scalars['String']['output'];
  /** API URL for the account */
  apiUrl: Scalars['String']['output'];
  /** Name of the account */
  name: Scalars['String']['output'];
  /** account status */
  status: UserApiAccountStatus;
};

export enum UserApiAccountStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}
